/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { LifeCycleState } from "../storage";

export const useProductStatus = (
  lifeCycleState: string | null | undefined,
  basePriceExcGst: number | undefined
) => {
  const noPriceAvailable = basePriceExcGst === undefined || basePriceExcGst <= 0.0;
  const isUnavailable = !lifeCycleState || noPriceAvailable;
  const isDiscontinued =
    lifeCycleState === LifeCycleState.OBSOLETE || lifeCycleState === LifeCycleState.DISCONTINUED;
  const isDisabled = isUnavailable || isDiscontinued;
  const isEndOfLife = lifeCycleState === LifeCycleState.END_OF_LIFE;
  const canPurchase = !isDisabled && !isEndOfLife;

  return {
    noPriceAvailable,
    isUnavailable,
    isDiscontinued,
    isDisabled,
    isEndOfLife,
    canPurchase,
  };
};
